import { render, staticRenderFns } from "./FlatMail.vue?vue&type=template&id=6b4f9c84&scoped=true&"
import script from "./FlatMail.vue?vue&type=script&lang=js&"
export * from "./FlatMail.vue?vue&type=script&lang=js&"
import style0 from "./FlatMail.vue?vue&type=style&index=0&id=6b4f9c84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4f9c84",
  null
  
)

export default component.exports